<template>
<div class="payment_methods">
  <BlockUI v-if="blockUI" message="Prosimo počakajte trenutek..."
           url="/images/loading-spinner.svg"></BlockUI>
</div>
</template>

<script>

import braintree from 'braintree-web';
import VueFormGenerator from "vue-form-generator/dist/vfg.js";

Vue.use(VueFormGenerator);
//    Vue.use(VueFormWizard);

import BlockUI from 'vue-blockui'

Vue.use(BlockUI);
import * as Sentry from '@sentry/browser';

export default {

  props: ["model", "schema", "env", "submit_url", "checkout"],

  data: function () {
    return {

      blockUI: false,

      /**
       * Set on init and used to generate client instances
       */
      braintree_client_token: null,

      /**
       * Available after tokenization
       */
      payment_method_nonce: null,
      payment_method_bin: null,
      payment_method_nonce_type: null,

      instances: {
        paypalCheckoutInstance: null,
        hostedFieldsInstance: null,
        threeDSecureInstance: null
      },

      validation: {
        braintree_credit_card_data: {

          cvv: {
            isEmpty: true,
            isValid: false,
            isPotentiallyValid: true,
            isFocused: false,
            container: "div#braintree_credit_card_cvv.form-control"
          },
          expirationMonth: {
            isEmpty: false,
            isValid: true,
            isPotentiallyValid: true,
            isFocused: false,
            container: "div#braintree_credit_card_expiration_date_month.form-control.braintree-hosted-fields-valid"
          },
          expirationYear: {
            isEmpty: false,
            isValid: true,
            isPotentiallyValid: true,
            isFocused: true,
            container: "div#braintree_credit_card_expiration_date_year.form-control.braintree-hosted-fields-valid"
          },
          number: {
            isEmpty: false,
            isValid: true,
            isPotentiallyValid: true,
            isFocused: false,
            container: "div#braintree_credit_card_number.form-control.braintree-hosted-fields-valid"
          },

        }
      },

    }

  },


  created() {
    Event.$on("process_payment", function () {
      this.processPayment();
    }.bind(this));

  },

  methods: {

    init: function (braintree_client_token) {
      console.log(process.env.NODE_ENV);

      this.braintree_client_token = braintree_client_token;
      this.model.braintree_credit_card_validation = {
        empty: 4,
        valid: false,
      };

      this.model.payment_failed = true;
      this.model.payment_method = "";

      // add payment methods

      this.schema.groups.push({
          fields: [
            {
              type: "failedPayment",
              text: "Se opravičujemo",
              id: "braintree_failed_payment",
              styleClasses: "braintree_credit_card_fields col-sm-12"

            },

            {
              type: "radios",
              label: "Kakšen način plačila vam ustreza?",
              model: "payment_method",
              values: [
                { value: "upn", name: "Plačilo preko spletne banke (UPN nalog)" },
                //                                    {value: "paypal", name: "PayPal"},
                { value: "braintree_paypal", name: "PayPal" },
                { value: "braintree_credit_card", name: "Kreditne kartice" },
              ],
              required: true,
              styleClasses: 'col-sm-12',
              validator: function (value, field, model) {
                if (value === "") {
                  return "Izberite način plačila, ki vam najbolj ustreza.";
                }

                if (value === "braintree_credit_card") {
                  if (model.braintree_credit_card_validation.empty > 0) {
                    return ["Vpišite spodnja polja:"];
                  } else if (model.braintree_credit_card_validation.valid === false) {
                    return ["Prosimo preverite spodnja polja."];
                  }
                }
              },
              onChanged: function (model, newVal, oldVal, field) {

                Event.$emit("braintree_payment_method_changed", model);
              },
              visible: function (model) {
                // waitlist only
                return model.price_total > 0;
              }
            },

            {
              type: "braintree",
              inputType: "text",
              label: " ",
              id: "braintree_credit_card_fields",
              model: "braintree_credit_card_fields",
              styleClasses: "braintree_credit_card_fields col-sm-12",

            }
          ]
        }
      );

      // remove upn
      if (this.checkout.id === 21) {
        this.schema.groups[1]["fields"][1].values.shift();
      }

      this.braintreeSetup();
    },


    braintreeSetup: function () {
      // Create a client.


      braintree.client.create({
        // Use the generated client token to instantiate the Braintree client.
        authorization: this.braintree_client_token
      }, (clientErr, clientInstance) => {
        if (clientErr) {
          // Handle error in client creation
          Sentry.captureException(clientErr);
          return;
        }

        this.setupThreeDSecure(clientInstance);

        this.setupHostedFields(clientInstance);

        this.setupPaypal(clientInstance);
      });


    },

    setupThreeDSecure(clientInstance) {
      braintree.threeDSecure.create({
        version: 2, // Will use 3DS 2 whenever possible
        client: clientInstance
      }).then((threeDSecureInstance) => {
        this.instances.threeDSecureInstance = threeDSecureInstance;
      }).catch((err) => {
        // Handle component creation error
        Sentry.captureException(err);
      });
    },

    setupHostedFields(clientInstance) {

      braintree.hostedFields.create({
        client: clientInstance,
        styles: {
          'input': {
            'font-size': '14px',
            'font-family': 'helvetica, tahoma, calibri, sans-serif',
            'color': '#3a3a3a'
          },
          ':focus': {
            'color': 'black'
          }
        },
        fields: {
          number: {
            selector: '#braintree_credit_card_number',
            placeholder: '4111 1111 1111 1111'
          },
          cvv: {
            selector: '#braintree_credit_card_cvv',
            placeholder: '123'
          },
          expirationMonth: {
            selector: '#braintree_credit_card_expiration_date_month',
            placeholder: 'MM'
          },
          expirationYear: {
            selector: '#braintree_credit_card_expiration_date_year',
            placeholder: 'LL'
          }
        }
      }, (err, hostedFieldsInstance) => {
        if (err) {
          Sentry.captureException(err);
        }

        this.instances.hostedFieldsInstance = hostedFieldsInstance;

        hostedFieldsInstance.on('validityChange', (event) => {

          this.braintreeCreditCardFieldsValidation(event);
          // cards: [{niceType: "Mastercard", type: "master-card", code: {…}}]
          // emittedBy:"expirationYear"
          // fields: {
          //     cvv: {isEmpty: true, isValid: false, isPotentiallyValid: true, isFocused: false, container: div#braintree_credit_card_cvv.form-control}
          //     expirationMonth: {isEmpty: false, isValid: true, isPotentiallyValid: true, isFocused: false, container: div#braintree_credit_card_expiration_date_month.form-control.braintree-hosted-fields-valid}
          //     expirationYear: {isEmpty: false, isValid: true, isPotentiallyValid: true, isFocused: true, container: div#braintree_credit_card_expiration_date_year.form-control.braintree-hosted-fields-valid}
          //     number: {isEmpty: false, isValid: true, isPotentiallyValid: true, isFocused: false, container: div#braintree_credit_card_number.form-control.braintree-hosted-fields-valid}
          // }

          let field = event.fields[event.emittedBy];

          if (field.isValid) {

            if (event.emittedBy === 'braintree_credit_card_expiration_date_month' || event.emittedBy === 'this.braintree_client_token') {
              if (!event.fields.expirationMonth.isValid || !event.fields.expirationYear.isValid) {
                return;
              }
            } else if (event.emittedBy === 'number') {
              $('#braintree_credit_card_number').next('span').text('');
            }

            // Remove any previously applied error or warning classes
            $(field.container).parents('.form-group').removeClass('has-error');
            //                                $(field.container).parents('.form-group').removeClass('has-success');
            // Apply styling for a valid field
            $(field.container).parents('.form-group').addClass('has-success');
            // } else if (field.isPotentiallyValid) {
            //   // Remove styling  from potentially valid fields
            //   $(field.container).parents('.form-group').removeClass('has-warning');
            //   $(field.container).parents('.form-group').removeClass('has-success');
            //   if (event.emittedBy === 'number') {
            //     $('#braintree_credit_card_number').next('span').text('');
            //   }
          } else {

            // Add styling to invalid fields
            $(field.container).parents('.form-group').removeClass('has-success');
            $(field.container).parents('.form-group').addClass('has-error');
            // Add helper text for an invalid card number
            if (event.emittedBy === 'number') {
              $('#braintree_credit_card_number').next('span').text(
                'Vpisana številka kartice ni veljavna.');
            }
          }
        });

        // hostedFieldsInstance.on('cardTypeChange',  (event)  => {
        //   // Handle a field's change, such as a change in validity or credit card type
        //   // if (event.cards.length === 1) {
        //   //   $('#card-type').text(event.cards[0].niceType);
        //   // } else {
        //   //   $('#card-type').text('Card');
        //   // }
        // });


      });

    },

    setupPaypal(clientInstance) {

      // Create a PayPal Checkout PaymentMethodsModule.
      braintree.paypalCheckout.create({
        client: clientInstance
      }, (paypalCheckoutErr, paypalCheckoutInstance) => {

        // Stop if there was a problem creating PayPal Checkout.
        // This could happen if there was a network error or if it's incorrectly
        // configured.
        if (paypalCheckoutErr) {
          console.error('Error creating PayPal Checkout:', paypalCheckoutErr);
          Sentry.captureException(paypalCheckoutErr);
        }

        this.instances.paypalCheckoutInstance = paypalCheckoutInstance;

        // Set up PayPal with the checkout.js library
        paypal.Button.render({
          env: this.env, // or 'sandbox'
          commit: true,

          payment: () => {

            console.log("ON PAYMENT");

            /**
             * {@link http://braintree.github.io/braintree-web/current/PayPalCheckout.html#createPayment Link}
             */

            let createPaymentObject = {
              flow: 'checkout', // Required
              intent: 'sale', // or authorize => submits the transaction for authorization
              //                                    amount: 555.00, // Required
              amount: this.model.price_pay_now, // Required
              currency: 'EUR', // Required
              displayName: true,
            };

            return paypalCheckoutInstance.createPayment(createPaymentObject);
          },
          onAuthorize: (data, actions) => {

            return paypalCheckoutInstance.tokenizePayment(data)
            .then((payload) => {

              // details
              //     :
              // {email: "sandbox@demi-solutions.com",firstName: "Jan", lastName: "Test", payerId: "MPGGJWKYK5QB6", shippingAddress: {…}, …}
              // nonce
              //     :
              //     "364c3904-c9df-047e-147a-51f7a4b76124"
              // type
              //     :
              //     "PayPalAccount"
              this.braintreeTokenize(payload, true);
              //                                        Event.$emit("braintree_paypal_tokenized");
              // Submit `payload.nonce` to your server.
            }).catch(function (err) {
              console.log("PAYPAL TOKENIZATION ERROR");
              Sentry.captureException(err);
            });
          },

          onCancel: function (data) {
            console.log('checkout.js payment cancelled', JSON.stringify(data));
            // checkout.js payment cancelled {
            //     "paymentToken": "EC-6M722053FD2395244",
            //         "cancelUrl": "https://example.com?token=EC-6M722053FD2395244"
            // }
          },

          onError: function (err) {
            Sentry.captureException(err);
            // console.error('checkout.js error', err);
          }
        }, '#paypal-button').then(function () {

        });
      });
    },


    resetPaymentMethodNonce() {
      this.payment_method_nonce = null;
      this.payment_method_bin = null;
      this.payment_method_nonce_type = null;
    },

    /**
     * Called from parent component
     * Handles tokenization and processing payments
     */
    processPayment: function () {
      this.blockUI = true;

      let paymentMethodsComponent = this;

      if (this.model.payment_method === "braintree_credit_card" && !this.payment_method_nonce) {

        this.instances.hostedFieldsInstance.tokenize()
        .then((payload) => {
          return this.instances.threeDSecureInstance.verifyCard({
            onLookupComplete: function (data, next) {
              next();
            },
            amount: this.model.price_pay_now,
            nonce: payload.nonce,
            bin: payload.details.bin,
            email: this.model.customer.email,
            billingAddress: {
              firstName: this.model.customer.first_name,
              lastName: this.model.customer.last_name,
              phoneNumber: this.model.customer.telephone,
              streetAddress: this.model.customer.address,
              locality: this.model.customer.city,
              postalCode: this.model.customer.postal_code,
            }
          });
        }).then((payload) => {
          if (payload.liabilityShifted) {
            this.braintreeTokenize(payload, true);
          } else {
            console.log('payload', payload);
            this.blockUI = false;
            Event.$emit("process_order_error", '3D Secure Verification');
          }
        })
        .catch((err) => {
          console.log('Error with 3d secure', err);
          this.blockUI = false;
          Event.$emit("process_order_error", '3D Secure Verification');
          Sentry.captureException(err);
        });

        return;
      }


      this.model.payment_method_nonce = this.payment_method_nonce;
      this.model.payment_method_nonce_type = this.payment_method_nonce_type;


      axios.post(this.submit_url, this.model)
      .then((response) => {

        if (response.data.success === true) {
          // redirect
          window.location = response.data.url;
          //                            console.log(response.data);
          //                            console.log(response.data.url);
        } else {
          // show error
          this.blockUI = false;
          Event.$emit("process_order_error", response.data.message);
          this.order_id = response.data.order_id;
        }

        this.payment_method_nonce = null;
      })
      .catch((error) => {
        this.blockUI = false;
        //                        console.log(error);
        //                        console.log("CATCH");

        this.resetPaymentMethodNonce();
      });
    },

    braintreeTokenize: function (data, processPayment) {
      //                console.log("DATA 1");
      //                console.log(data);
      this.payment_method_nonce = data.nonce;

      if (data.type === "PayPalAccount") {
        this.payment_method_nonce_type = "braintree_paypal";
      } else if (data.type === "CreditCard") {
        this.payment_method_nonce_type = "braintree_credit_card";
        this.payment_method_bin = data.details.bin;
      }

      //                console.log("After otkenization");
      //
      //                console.log(this.payment_method_nonce);

      if (processPayment) {
        this.processPayment();
      }

    },

    braintreeCreditCardFieldsValidation(event) {
      this.validation.braintree_credit_card_data = event.fields;
      let valid = 0;
      let empty = 0;
      for (let key in event.fields) {
        if (event.fields.hasOwnProperty(key)) {
          if (event.fields[key].isValid === true) {
            valid++;
          }
          if (event.fields[key].isEmpty) {
            empty++;
          }
        }
      }
      this.model.braintree_credit_card_validation.valid = (valid === 4);
      this.model.braintree_credit_card_validation.empty = empty;

      this.$parent.$refs.paymentMethodsForm.validate();
    },


  },


}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/modules/PaymentMethodsBS3.vue